module.exports = __webpack_public_path__ + "8fd90c6592f8b55695e0141425e422fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/CoreLayout/img/user_logo.jpg
// module id = 1376
// module chunks = 0